import { ReactNode } from 'react';

interface ShowProps<T> {
  when: T | null | undefined;
  children: ReactNode | ((value: T) => ReactNode);
}

export const Show = <T,>({ when, children }: ShowProps<T>) => {
  if (when === null || when === undefined || when === false) {
    return null;
  }

  return typeof children === 'function' ? children(when) : children;
};
